
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/teamsreminder-remote-team-productivity-guide",
      function () {
        return require("private-next-pages/article/teamsreminder-remote-team-productivity-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/teamsreminder-remote-team-productivity-guide"])
      });
    }
  